module.exports = __webpack_public_path__ + "static/img/zf_img_service.19ed7b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jieju/zf_img_service.png
// module id = ND93
// module chunks = 1